import { Translate } from '@chipinside/translate'
import { Box, Stack, styled, Typography } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import { inRange, isEmpty } from 'lodash'

import { Icon } from '#/components/Icon'
import Palette from '#/styles/Palette'

const TitleStyled = styled(Typography)({
  fontSize: '32px',
  fontWeight: '500',
})

const Message = styled(Typography)({
  color: Palette.gray.dark[900],
  fontSize: '16px',
  textAlign: 'center',
})

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
export const getHeaderCustomization = code => {
  let icon = <Icon name="attention" size={70} />
  let text = Translate({ messageKey: 'response_error' })
  let color = Palette.gray.self['500']

  // Informational responses
  if (inRange(code, 100, 199)) {
    icon = <Icon name="info" size={90} />
    text = Translate({ messageKey: 'response_info' })
    color = Palette.blue.dark[500]
  }

  // Successful responses
  if (inRange(code, 200, 299)) {
    icon = <Icon name="success" size={70} />
    text = Translate({ messageKey: 'response_success' })
    color = Palette.green.self[500]
  }

  // Client error responses
  if (inRange(code, 400, 499)) {
    icon = <Icon name="attention" size={70} />
    text = Translate({ messageKey: 'response_warning' })
    color = Palette.orange.self[500]
  }

  // Server error responses
  if (inRange(code, 500, 599)) {
    icon = <Icon name="attention" size={70} />
    text = Translate({ messageKey: 'response_error' })
    color = Palette.red.self[400]
  }

  return { color, icon, text }
}

const RenderDetails = ({ details }) => {
  if (!isEmpty(details)) {
    let formattedDetails = Object.entries(details)
      .flatMap(([, value]) => {
        if (typeof value === 'string' || typeof value === 'number') {
          return value
        }
        if (Array.isArray(value)) {
          return value.filter(item => typeof item === 'string' || typeof item === 'number')
        }
      })
      .filter(Boolean)

    return (
      <Stack spacing={1}>
        {formattedDetails.map((item, idx) => (
          <Typography key={`detail-${idx}`} sx={{ color: 'grey.900', textAlign: 'center' }}>
            {item}
          </Typography>
        ))}
      </Stack>
    )
  }

  return null
}
const ResponseContent = ({ code, details, message }) => {
  const { color, icon, text } = getHeaderCustomization(code)
  return (
    <DialogContent
      style={{
        alignItems: 'center',
        color,
        display: 'flex',
        flexDirection: 'column',
        marginTop: 24,
        paddingTop: 24,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          color,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {icon}
        <TitleStyled>{text}</TitleStyled>
        {message ? (
          <Stack spacing={0.5} sx={{ mt: 2 }}>
            <Message>{message}</Message>
            <RenderDetails details={details} />
          </Stack>
        ) : null}
      </Box>
    </DialogContent>
  )
}

export { ResponseContent }
